import React from 'react';
import { CardGroup, Container, CTABlock, Icon, Paper } from 'library';

import TEAM from '../../../constants/team';

import './MeetTheTeamBlock.scss';

const TeamMemberSize = { width: 235 };

const TeamMember = ({ member }) => {
  return (
    <div className="TeamMember" style={TeamMemberSize}>
      <img src={member.image} alt={member.name} />
      <h5>{member.name}</h5>
      <p>{member.title}</p>
      <div className="TeamMemberBlurb">{member.blurb}</div>
    </div>
  );
};

const MeetTheTeamBlock = ({ data }) => {
  return (
    <Paper className="MeetTheTeamBlock" theme="medium">
      <Container row justify="center">
        <Container grid="8">
          <CTABlock
            title="Meet our Team"
            text="We’re led by a team known for creating successful, customer-first businesses. Backed by top-tier
                investors, we’ve built, run, and exited some of the fastest growing companies in the US."
            buttonLabel={
              <span>
                View Careers Page <Icon name="arrow-right" pullRight />
              </span>
            }
            buttonLink="/careers"
            buttonTheme="text"
          />
        </Container>
      </Container>
      <Container>
        <div>
          <CardGroup size={TeamMemberSize} cardAlignment="center">
            {TEAM.map((member, index) => {
              return <TeamMember member={member} key={index} />;
            })}
          </CardGroup>
        </div>
      </Container>
    </Paper>
  );
};

export default MeetTheTeamBlock;
